<template>
  <div id="edit_visit">
    <div class="page-header section-image" data-parallax="true" style="background-image: url('/static/img/activities.jpg'); height:50vh; background-position:0px 75%" >
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="brand text-center">
              <h1 class="title">(編輯)活動花絮</h1>
              <h3 class="title description">(Edit)Activities </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-raised -->
    <div class="main">
      <div class="container">
        <div class="progress" style="height: 10px;" v-if="prossVal !=0">
            <div class="progress-bar" role="progressbar" :style="{width: prossVal + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{prossVal}}%</div>
        </div>
        <div class="section">
          <button class="btn btn-social btn-fill btn-behance" @click="save_data">
              <span class="material-icons mr-2">save_alt</span> 儲存
          </button>
          <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
              <span class="material-icons mr-2">keyboard_return</span> 取消編輯
          </button>
          <template v-for="(item, index) in f_data">
            <table class="table table-bordered" :key="index">
              <tr class="thead-light">
                <th style="width:10%">
                  <button  class="btn btn-link btn-facebook" data-toggle="collapse" :data-target="'.' + item.plan_type">
                      <span class="material-icons mr-2">list</span>摺疊
                  </button>
                </th>
                <th colspan="3" style="vertical-align : middle">{{ item.plan_type.replace('_','、') }}</th>
              </tr>
              
              <tr :class="item.plan_type +' collapse show'">
                <th style="width:10%"></th>
                <th style="width:20%" class="text-center">時間</th>
                <th class="text-center">活動名稱</th>
                <th style="width:20%" class="text-center">封面照</th>
              </tr>
              <template v-for="(sub_item, sub_i) in item.list">
                <tr :key="index + sub_i" :class="item.plan_type +' collapse show'">
                  <td>
                    <button v-if="sub_item.del == 0" class="btn btn-link btn-twitter" @click="del(index, sub_i)">
                        <span class="material-icons">remove_circle_outline</span>刪除
                    </button>
                    <button v-else class="btn btn-link btn-twitter" @click="cancel_del(index, sub_i)">
                        <span class="material-icons">delete_sweep</span>取消刪除
                    </button>
                  </td>
                  <td>
                    <input type="text" class="form-control" v-model="sub_item.plan_time" v-if="sub_item.del == 0">
                    <input type="text" class="form-control  text-danger font-italic" v-model="sub_item.plan_time" readonly v-else>
                  </td>
                  <td>
                    <input type="text" class="form-control" v-model="sub_item.plan_name" v-if="sub_item.del == 0">
                    <input type="text" class="form-control  text-danger font-italic" v-model="sub_item.plan_name" readonly v-else>
                  </td>
                  <td>
                    <template v-if="sub_item.del == 0">
                      <img style="width:50%;" :src="sub_item.main_img" />
                      <label class="btn btn-info">
                        <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index, sub_i)" />
                        <i class="fa fa-photo"></i> 上傳圖片
                      </label>
                    </template>
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="4">
                  <button class="btn btn-social btn-fill btn-facebook" @click="add(index)">
                    <span class="material-icons mr-2">control_point</span> 新增
                  </button>
                </td>                
              </tr>
          </table>
          </template>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_visit",
  props: [],
  components: {
    
  },
  data() {
    return {
			pages: [],
      data:[],
      f_data:[],
      imgFile: [],
      imgNumLimit: 1,
      imgString: [],
      prossVal: 0
    };
  },
  filters: {},
  computed:{},
  watch: {},
  methods: {
    getData: function(){
      var vm = this;
      var data = []
      var newItem = []
      
      axios
        .get(`/api/getvisit`)
        .then(res => {
          // vm.data = res.data;
          data = res.data.data;
          // 排序plan_type
          data = data.sort(function (a, b) {
            return a.plan_type > b.plan_type ? 1 : -1;
            });

          // ====== 整理 開始=======    
           for(var i = 0; i < data.length; i++){
            if(i == 0){
              newItem.push({
                plan_type: data[i].plan_type,
                list:[{
                  del:0,
                  id: data[i].id,
                  plan_time: data[i].plan_time,
                  plan_name: data[i].plan_name,
                  main_img: data[i].main_img
                }]
              });
            }
            else{
              var last_type = newItem[newItem.length-1].plan_type;
              if(last_type == data[i].plan_type){
                newItem[newItem.length-1].list.push({
                  del:0,
                  id: data[i].id,
                  plan_time: data[i].plan_time,
                  plan_name: data[i].plan_name,
                  main_img: data[i].main_img
                })
              }
              else{
                newItem.push({
                  plan_type: data[i].plan_type,
                  list:[{
                    del:0,
                    id: data[i].id,
                    plan_time: data[i].plan_time,
                    plan_name: data[i].plan_name,
                    main_img: data[i].main_img
                  }]
                });
              }
            }
          }
          vm.f_data = newItem;
          // ====== 整理 結束=======     
        })
        .catch(err => {
          console.log(err);
        });      
    },
    async save_data(){
      var vm = this;
      var data = [];
      // vm.f_data.forEach(function(item, idx){
      //   var list = item.list;
      //   list.forEach(function(sub_item, sub_idx){
      //     data.push({
      //       id: sub_item.id,
      //       del: sub_item.del,
      //       plan_type: item.plan_type,
      //       plan_time: sub_item.plan_time,
      //       plan_name: sub_item.plan_name,
      //       main_img: sub_item.main_img,
      //     })
      //   })
      // });

      for(var i = 0; i < vm.f_data.length; i++){
        var list = vm.f_data[i].list;

        for(var j = 0; j < list.length; j++){
          await vm.dataVisit({
            id: list[j].id,
            del: list[j].del,
            plan_type: vm.f_data[i].plan_type,
            plan_time: list[j].plan_time,
            plan_name: list[j].plan_name,
            main_img: list[j].main_img,
          })
        }

        vm.prossVal = Math.floor(( i / vm.f_data.length )*100);

      }
      vm.$router.push("/visit");
      
      // console.log(data);
      // axios
      //   .post(`${process.env.API_PATH}/api/savevisit`, data)
      //   .then(res => {
      //     if(res.status == 200){
      //       vm.$router.push("/visit");
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },    
    // 儲存
    async dataVisit(data){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savevisit`,data)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    cancel_edit: function(){
      this.$router.push("/visit");
    },
    uploadImg: function(e, index, sub_i) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);

              // var expectWidth = this.naturalWidth;
              // var expectHeight = this.naturalHeight;
              // var scale = expectWidth / expectHeight;
              // var width_x = 300;
              // var height_x = parseInt(width_x / scale);
              // var canvas = document.createElement("canvas");
              // var ctx = canvas.getContext("2d");
              // canvas.width = width_x;
              // canvas.height = height_x;
              // ctx.drawImage(this, 0, 0, expectWidth, expectHeight, 0, 0, width_x, height_x);

              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 0.8);
              _this.imgString.push({ src: base64 });

              // if (fileList[i].size / 1024000 > 1) {
              //   console.log('行643: 壓縮')
              //   _this.imgScale(base64, 4);
              // } 
              // else {
              //   console.log('行647: 未壓縮')
              //   _this.imgString.push({ src: base64 });
              // }
              _this.f_data[index].list[sub_i].main_img = _this.imgString[0].src;
              
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    add: function(index){
      var vm = this;
      vm.f_data[index].list.push({
          del:0,
          id: null,
          plan_time: '',
          plan_name: '',
          main_img: ''
      })
    },
    del: function(index, sub_i){
      this.f_data[index].list[sub_i].del = 1;
    },
    cancel_del: function(index, sub_i){
      this.f_data[index].list[sub_i].del = 0;
    },
  },
  created() {
    this.getData();
  },
  mounted() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/visit/edit_visit.vue